<template>
	<tr v-on:click="onClick()" class="table blanco">
		<td class="table-row name-size ">
			<div
				v-on:click.stop="openDetailsPage()"
				class="pa-0 text-left project-size"
			>
				{{ processed.projectName }}
			</div>
		</td>
		<td class="table-row description-size">
			<div class="ma-0 pa-0">
				<div class="text--secondary pt-1">
					<div
						v-if="processed.description.length < 100"
						class="description-size"
					>
						{{ processed.description }}
					</div>
					<div v-else class="description-size">
						{{ processed.description.substring(0, 97) + "..." }}
					</div>
				</div>
				<div class="cameras-size">
					{{
						$tc("camerasProcessed", [processed.cameras], {
							cams: processed.cameras,
						})
					}}
				</div>
			</div>
		</td>
		<td class="table-row recording-size">
			{{ processed.recordings }}
		</td>
		<td class="table-row text--secondary">
			<ExpirationCounter :date="processed.expirationDate" />
		</td>
		<td class="table-row">
			<status-box
				:status="processed.status"
				class="table-row"
				:projectId="processed.id"
				:isProgress="true"
				:progressValue="processed.progress"
				:key="statusKey"
			/>
		</td>
		<!--
    <td class="ma-0 pa-0 table-row">
      <icon class="icon-size" v-if="processed.download" @clicked="openDetailsPage" icon="mdi-arrow-down-circle-outline" :name="$t('download')"/>
      <icon class="icon-size" v-if="processed.auditActions" @clicked="auditResult(true)" icon="mdi-check-circle-outline" :name="$t('audit.pre-approve')" :disableIcon="(project.status==='Approved')"/>
      <icon class="icon-size" v-if="processed.auditActions" @clicked="auditResult(false)" icon="mdi-close-circle-outline" :name="$t('audit.deny')"  :disableIcon="(project.status==='Denied')"/>
      <icon class="icon-size" v-if="processed.legalAuditActions" @clicked="legalAuditResult(true)" icon="mdi-check-circle-outline" :name="$t('audit.approve')" :disableIcon="(project.status==='Approved')"/>
      <icon class="icon-size" v-if="processed.legalAuditActions" @clicked="legalAuditResult(false)" icon="mdi-close-circle-outline" :name="$t('audit.deny')"  :disableIcon="(project.status==='Denied')"/>
    </td>-->
	</tr>
</template>

<script>
import ExpirationCounter from "./ExpirationCounter";
//import Icon from '@/components/base/Icon'
import PermissionMixin from "@/mixins/PermissionMixin";

export default {
	mixins: [PermissionMixin],
	props: {
		icon: String,
		project: Object,
		items: {
			type: Number,
			default: function() {
				return [];
			},
		},
	},
	components: {
		ExpirationCounter,
		//Icon
	},
	data() {
		return {};
	},
	mounted() {
		if (this.items % 2 === 0) {
			var miElto = document.getElementsByClassName("blanco")[this.items];
			miElto.classList.add("gris");
		}
	},
	computed: {
		processed: {
			get() {
				return {
					projectName: this.project.projectName,
					description: this.project.description,
					startedBy: this.project.startedBy,
					cameras: this.cameraCount,
					hours: this.totalhours(),
					recordings: this.recordings,
					creationDate: this.project.creationDate,
					expirationDate: this.project.expirationDate,
					status: this.project.status,
					size: this.size,
					downloaders: this.project.downloaders,
					//download: (((this.userCanAudit || this.userCanLegalAudit)&&((this.project.status==="Finished")||(this.project.status==="PreApproved")||(this.project.status==="Denied")))),
					//auditActions: ((this.userCanAudit)&&((this.project.status==="Finished")||(this.project.status==="PreApproved")||(this.project.status==="Denied"))),
					//legalAuditActions:((this.userCanLegalAudit)&&((this.project.status==="PreApproved")||(this.project.status==="Approved")||(this.project.status==="Denied"))),
					extractions: this.project.extractions,
					statusLogs: this.project.statusLogs,
					organismName: this.project.organismName,
					id: this.project.id,
					progress: this.project.progress,
				};
			},
		},
		recordings: {
			get() {
				var min, max;
				min = new Date(
					this.project.extractions[0].downloadTimeRange.split(/( - )/)[0] +
						" UTC"
				);
				max = new Date(
					this.project.extractions[0].downloadTimeRange.split(/( - )/)[2] +
						" UTC"
				);
				this.project.extractions.forEach((extraction) => {
					var from, to;
					from = new Date(
						extraction.downloadTimeRange.split(/( - )/)[0] + " UTC"
					);
					to = new Date(
						extraction.downloadTimeRange.split(/( - )/)[2] + " UTC"
					);
					if (from < min) min = from;
					if (to > max) max = to;
				});

				return (
					"Grabaciones desde " +
					min.toLocaleDateString() +
					" hasta " +
					max.toLocaleDateString()
				);
			},
		},
		cameraCount: {
			get() {
				var cameraFound = [];
				this.project.extractions.forEach((extraction) => {
					if (!cameraFound.includes(extraction.cameraName))
						cameraFound.push(extraction.cameraName);
				});
				return cameraFound.length;
			},
		},
		size: {
			get() {
				var a = 0;
				if (
					this.project.status === "Finished" ||
					this.project.status === "Approved" ||
					this.project.status === "Denied" ||
					this.project.status === "Expired"
				) {
					this.project.extractions.forEach((extr) => {
						a += extr.totalSize;
					});
					return a;
				}
				return a;
			},
		},
		statusKey: {
			get() {
				return this.$store.getters.getStatusKey;
			},
		},
	},
	methods: {
		openDetailsPage() {
			this.$store.commit("setProjectForDetails", this.project.id);
			this.$router.push("/details");
		},
		onClick() {
			this.$store.dispatch("triggerDetailsDrawer", {
				displayDrawer: true,
				detailedProject: this.processed,
				projectRaw: this.project,
			});
			this.$emit("drawerKey");
		},
		totalhours() {
			var res = 0;
			if (this.project.extractions.lenght < 1) return res;
			this.project.extractions.forEach((extr) => {
				var dts = new Date(extr.downloadTimeRange.split(" - ")[0]);
				var dte = new Date(extr.downloadTimeRange.split(" - ")[1]);
				res = res + (dte.getTime() - dts.getTime()) / 1000 / 60 / 60;
			});
			return res;
		},
	},
};
</script>
<style>
.table:hover {
	background-color: inherit !important;
}
.table {
	font-family: "Open Sans", "sans-serif";
	font-weight: 500;
	cursor: pointer;
}
.gris:hover {
	background-color: #f8faff !important;
}
.gris {
	background-color: #f8faff !important;
}
.icon-hover:hover {
	color: #2196f3 !important;
}
.description-size {
	width: 330px !important;
}
.icon-column {
	width: 20px !important;
}
.name-size {
	max-width: 250px !important;
	color: #0d5ae5;
	padding-right: 0px !important;
}
.recording-size {
	width: 360px !important;
}
.table-row {
	font-size: 14px !important;
	border-bottom: none !important;
	text-align: left !important;
}
.color-table {
	background-color: #f5fdfd;
}
.cameras-size {
	color: #91919c;
	font-weight: 600;
}
.project-size {
	cursor: pointer;
}
@media (max-width: 1570px) {
	.description-size {
		width: 290px !important;
	}
	.recording-size {
		width: 330px !important;
	}
}
@media (max-width: 1500px) {
	.description-size {
		width: 250px !important;
	}
	.name-size {
		max-width: 150px !important;
	}
	.recording-size {
		width: 290px !important;
	}
}
@media (max-width: 1410px) {
	.recording-size {
		width: 240px !important;
	}
	.description-size {
		width: 180px !important;
	}
	.name-size {
		max-width: 130px !important;
	}
}
@media (max-width: 1045px) {
	.table-row-icon-folder {
		font-size: 16px !important;
	}
	.table-row {
		font-size: 13px !important;
	}
	.recording-size {
		width: 130px !important;
	}
	.description-size {
		width: 130px !important;
	}
	.name-size {
		max-width: 110px !important;
	}
}
@media (max-width: 995px) {
	.cameras-size {
		width: 55% !important;
	}
	.icon-size {
		font-size: 12px !important;
	}
}
</style>
